var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgGlobe16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.53333 15.3333C12.5834 15.3333 15.8667 12.0501 15.8667 8C15.8667 3.94991 12.5834 0.666667 8.53333 0.666667M8.53333 15.3333C4.48325 15.3333 1.2 12.0501 1.2 8C1.2 3.94991 4.48325 0.666667 8.53333 0.666667M8.53333 15.3333C8.78128 15.3333 9.07323 15.2189 9.39958 14.8969C9.72881 14.5719 10.0559 14.0687 10.3449 13.3942C10.922 12.0477 11.2953 10.141 11.2953 8C11.2953 5.85899 10.922 3.95229 10.3449 2.60576C10.0559 1.93131 9.72881 1.4281 9.39958 1.10318C9.07323 0.781091 8.78128 0.666667 8.53333 0.666667M8.53333 15.3333C8.28539 15.3333 7.99342 15.2189 7.66706 14.8969C7.33784 14.5719 7.01077 14.0687 6.72172 13.3942C6.14464 12.0477 5.77142 10.141 5.77142 8C5.77142 5.85899 6.14464 3.95229 6.72172 2.60576C7.01077 1.93131 7.33784 1.4281 7.66706 1.10318C7.99342 0.781091 8.28539 0.666667 8.53333 0.666667M1.67617 5.04759H15.3905M1.67617 10.7619H15.3905",
    stroke: "#8F8B8F",
    strokeWidth: 1.25
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGlobe16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;